const ViewData = ({ viewType, kanban, list }) => viewType ? kanban : list

export { ViewData }